// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__2dFgu","status":"styles_status__1hRs9","active":"styles_active___XOhM","inactive":"styles_inactive__2RXk2"};